/*
 * File: /src/shared/axiosBasePath.js
 * Created Date: Saturday April 6th 2019
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Sunday, 7th April 2019 7:27:19 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2019 AdBase, Inc.
 */

export const getBasePath = () => {
  // Use injected container vars first, then env file.
  if (window.s2Config && window.s2Config.VUE_APP_API_HOST) {
    return window.s2Config.VUE_APP_API_HOST;
  }
  if (process.env.VUE_APP_API_HOST) {
    return process.env.VUE_APP_API_HOST;
  }
  throw ('API HOST MUST BE DEFINED');

  // TODO: add in version number into route!
  const pathUriStructure = '%p//%s/';
  let basePath = '';
  // return pathUriStructure
  //     .replace('%p', window.location.protocol)
  //     .replace('%s', 'app-api.sendsquared.com');
  // console.log('ENV Type');
  // console.log(process.env.NODE_ENV);
  if (process.env.NODE_ENV === 'development') {
    basePath = pathUriStructure
      .replace('%p', window.location.protocol)
      .replace('%s', 'localhost:3000');
  } else {
    basePath = pathUriStructure
      .replace('%p', window.location.protocol)
      .replace('%s', 'app-api.sendsquared.com');
  }
  return basePath;
};

/**
 * Connector Path
 * @returns string
 */
export const getConnectorPath = () => {
  if (window.s2Config && window.s2Config.VUE_APP_CONNECTOR_HOST) {
    return window.s2Config.VUE_APP_CONNECTOR_HOST;
  }
  if (process.env.VUE_APP_CONNECTOR_HOST) {
    return process.env.VUE_APP_CONNECTOR_HOST;
  }
  // Not required but it will break stuff
  console.error('NO CONNECTOR HOST PROVIDED');
  return;

  const pathUriStructure = '%p//%s/';
  let basePath = '';
  if (process.env.NODE_ENV === 'development') {
    basePath = pathUriStructure
      .replace('%p', window.location.protocol)
      .replace('%s', 'localhost:8088');
  } else {
    basePath = pathUriStructure
      .replace('%p', window.location.protocol)
      .replace('%s', 'connector-api.sendsquared.com');
  }
  return basePath;
};
